import { render } from "./DadosDebitoVeicular.vue?vue&type=template&id=71edd64c"
import script from "./DadosDebitoVeicular.vue?vue&type=script&lang=js"
export * from "./DadosDebitoVeicular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__